import React from 'react';
import ShowcaseSection from 'containers/artPage/artShowcase';
import Footer from 'containers/footer';

import {useDataValue} from 'globals/contexts/dataContext';

import './artPage.css';

const ArtPage = () => {
  const [{content, currentLanguage}] = useDataValue();
  const pageContent = content['content'][currentLanguage]['pages']['art'];
  return <div id="art" className="page">
    <ShowcaseSection content={pageContent['landing']} />
    <Footer />
  </div>;
};

export default ArtPage;